import { render, staticRenderFns } from "./ScreenRellenarPagos.vue?vue&type=template&id=4a0fdf00"
import script from "./ScreenRellenarPagos.vue?vue&type=script&lang=js"
export * from "./ScreenRellenarPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports